
import React, {useEffect, useRef, useState} from "react";
import {Document as IDocument, Document} from "../../models/Document";
import {Backdrop, CircularProgress} from "@mui/material";
import {translateFunction} from "../../../../localization/TranslationService";
import {DocumentActionsCard} from "../document/DocumentActionsCard";
import {DocumentMeta} from "../../models/DocumentMeta";
import {DocumentValidation} from "../../models/DocumentValidation";
import {DocumentAudit} from "../../models/DocumentAudit";
import {MetaCard} from "../document/MetaCard";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {REINDEX_DOCUMENT} from "../graphql/mutations/gqlReindexDocument";
import {toast} from "react-toastify";
import {ValidationSeverity} from "../../models/ValidationSeverity";
import {MetaObject} from "../../models/MetaObject";


const translate = translateFunction("SureBaseDocuments");
interface IReindexDocumentCardProps{
	navigateToId?: (id: number) => void;
	navigateToIdentifier?: (id: string) => void;
	document: Document;
	onClose?: () => void;
	reloadDocument?: () => void;
	onMetaDataChanged?: (metaData: DocumentMeta[] | null) => void;
	onValidationsChanged?: (validationData: DocumentValidation[] | null) => void;
	onAuditsChanged?: (auditData: DocumentAudit[] | null) => void;
	validations?: DocumentValidation[] | null;
	documentIsValid: boolean;
	editComment?: () => void;
}


export const ReindexDocumentCard: React.FC<IReindexDocumentCardProps> = (props) => {
	const document = useRef<IDocument>(JSON.parse(JSON.stringify(props.document)));
	const [submitLoading, setSubmitLoading] = useState<boolean>(false);
	const [documentIsValid, setDocumentIsValid] = useState<boolean>(false);
	const [updateCount, setUpdateCount] = useState<number>(0);

	useEffect(() => {
		setDocumentIsValid(((document.current?.validations?.filter((it) => it.severity === ValidationSeverity.ERROR && it.field).length)??0) === 0);
		if (document.current) {
			const metaObject = new MetaObject(document.current.metaData);
			metaObject.newTask = false;
			metaObject.newClaim = false;
			setUpdateCount(u=> u+1);
		}
	}, []);
	const reindexDocument = async() => {
		setSubmitLoading(true);

		if (!document.current)
			return;

		graphQLServices.documentsClient.mutate({
			mutation: REINDEX_DOCUMENT,
			variables: {
				input: {
					documentIdentifier: document.current.identifier,
					metaData: document.current.metaData
				}
			},
		})
			.then((data) => {
				props.navigateToId && props.navigateToId(data.data.reindexDocument.id);
				props.navigateToIdentifier && props.navigateToIdentifier(data.data.reindexDocument.identifier);
				props.onClose && props.onClose();
				toast.success(translate(`Reindex started`));
			})
			.catch((reason) => {
				toast.error(translate(`Reindex failed.` + reason));
			} )
			.finally(() => {
				setSubmitLoading(false);
			});

	};

	function onMetaDataChanged(newMetaData: DocumentMeta[]|null) {
		if (document.current) {
			document.current.metaData = newMetaData;
		}
	}

	function onValidationDataChanged(validationData: DocumentValidation[]|null) {
		if (document.current) {
			document.current.validations = validationData;
			setDocumentIsValid(((document.current?.validations?.filter((it) => it.severity === ValidationSeverity.ERROR && it.field).length)??0) === 0);
		}
	}

	function onAuditDataChanged(auditData: DocumentAudit[]|null) {
		if(document.current) {
			document.current.audits = auditData;
		}
	}


	return <>
		<Backdrop open={submitLoading}><CircularProgress/></Backdrop>

		{ props.document && (
			<>
				<DocumentActionsCard
					key={"metaCard"}
					readOnly={false}
					document={document.current}
					documentIsValid={documentIsValid}
					reindexMode
					editComment={() => props.editComment}
					locked={false}
					reindex={() => reindexDocument()}
				/>
				<MetaCard
					key={"metaCard" + updateCount}
					readOnly={false}
					documentId={document.current.id??0}
					metaData={document.current.metaData??[]}
					onMetaDataChanged={onMetaDataChanged}
					onValidationsChanged={onValidationDataChanged}
					onAuditsChanged={onAuditDataChanged}
					validations={document.current.validations}
					hideFields={["target"]}
				/>
			</>
		)
		}

	</>;
};
